import { createGlobalStyle } from 'styled-components';

export const colors = {
  green: '#54AEB4',
  darkGreen: '#428D93',
  background: '#F7F7F7',
  red: 'red',
  gray: '#7E91A2',
  white: '#FFFFFF',
  border: '#D3E3F4',
  lightGray: '#E2E6E8',
  dark: '#1D3346',
  input: '#CFD7E0',
  stripeInvalidBorder: '#fa755a',
  stripeInvalid: '#9e2146',
  stripeBoxShadow: '#e6ebf1',
  stripeFocus: '#cfd7df',
};

export const GlobalStyle = createGlobalStyle({
  'html,body': {
    backgroundColor: colors.background,
    fontFamily: '"Roboto", sans-serif',
    height: '100%',
    scrollBehavior: 'smooth',
  },
  'input[type=text]:focus': {
    border: 'none!important',
  },
  small: {
    a: {
      textDecoration: 'underline',
    },
  },
  a: {
    cursor: 'pointer',
  },
  span: {
    fontSize: '15px',
  },
  h1: {
    fontSize: '36px',
    textAlign: 'center',
  },
  h2: {
    fontSize: '30px',
    textAlign: 'center',
  },
  h3: {
    fontSize: '24px',
    textAlign: 'center',
  },
  '.Toastify__toast--info, .Toastify__toast--success': {
    background: `${colors.darkGreen}!important`,
  },
  '.ReactModal__Body--open': {
    overflow: 'hidden',
    position: 'fixed',
    width: '100%',
    height: '100%',
  },
  '.StripeElement': {
    padding: '10px 12px',
  },
  '.StripeElement, input[type=text]': {
    height: '40px',
    width: '100%',
    backgroundColor: colors.white,
    border: '1px solid transparent',
    borderRadius: '4px',
    boxShadow: `0 1px 3px 0 ${colors.stripeBoxShadow}`,
    transition: 'box-shadow 150ms ease',
    fontSize: '16px',
    fontWeight: 500,
  },
  '.StripeElement--invalid': {
    borderColor: `${colors.stripeInvalidBorder}`,
    color: `${colors.stripeInvalid}`,
  },
  '.StripeElement--focus, .StripeElement:focus': {
    boxShadow: `0 1px 3px 0 ${colors.stripeFocus}`,
  },
  '.cardNameInvalid': {
    borderColor: `${colors.stripeInvalidBorder}!important`,
  },
  /* Extra small devices (phones, 600px and down) */
  '@media screen and (max-width: 660px)': {
    h1: {
      span: {
        fontSize: '30px!important',
      },
    },
    h2: {
      span: {
        fontSize: '26px!important',
        textAlign: 'justify',
      },
    },
    h3: {
      span: {
        fontSize: '22px!important',
      },
    },
    span: {
      fontSize: '13px!important',
    },
    button: {
      fontSize: '13px!important',
      span: {
        fontSize: '13px!important',
      },
    },
    small: {
      span: {
        fontSize: '17px!important',
      },
    },
    a: {
      fontSize: '17px',
    },
  },
  /* Small devices (portrait tablets and large phones, 600px and up) */
  '@media only screen and (min-width: 600px)': {
    h1: {
      span: {
        fontSize: '36px!important',
      },
    },
    h2: {
      span: {
        fontSize: '30px!important',
      },
    },
    h3: {
      span: {
        fontSize: '26px!important',
      },
    },
    span: {
      fontSize: '16px!important',
    },
    button: {
      span: {
        fontSize: '14px!important',
      },
    },
    small: {
      span: {
        fontSize: '15px!important',
      },
    },
    a: {
      fontSize: '15px',
      span: {
        fontSize: '14px!important',
      },
    },
  },
  /* Small devices (portrait tablets and large phones, 600px and up) */
  '@media only screen and (max-width: 370px)': {
    button: {
      span: {
        fontSize: '11px!important',
      },
    },
  },
});
